import { render } from "./AdicionarComentarioAtendimento.vue?vue&type=template&id=97e343f2&scoped=true"
import script from "./AdicionarComentarioAtendimento.vue?vue&type=script&lang=js"
export * from "./AdicionarComentarioAtendimento.vue?vue&type=script&lang=js"

import "./AdicionarComentarioAtendimento.vue?vue&type=style&index=0&id=97e343f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97e343f2"]])

export default __exports__